


<div class="col-md-12" *ngIf="travellerDetail" >
    <div class="outside-container mt-4">
        <div class="box-container ">
          <div *ngIf="userType==='STAFF'" class="col-md-12 row d-flex justify-content-center " style="padding-left: 20px; ">
            First, emulate the user,  <mat-icon style="width: 50px;" class="pointer">forward</mat-icon> and then proceed to the booking page    
    
          </div>
            <div *ngIf="userType!='STAFF'" class="col-md-12 row d-flex justify-content-center " style="padding-left: 20px; ">
              <div *ngIf="swingGenerate" class=" col-md-12 gif-container">  <img   src="../../../assets/images/insurancePending.gif" alt=""    >  </div> 
              
                <div *ngIf="!swingGenerate" class="col-md-12 row">
                <div *ngIf="!paymentDetail" class="col-md-9" style=" height:85vh;overflow-y: auto;">
              <mat-stepper orientation="vertical" [linear]="true" #stepper style="min-width: 100%;">
                <mat-step [stepControl]="firstFormGroup">
                  <form [formGroup]="firstFormGroup">
                    <ng-template matStepLabel>Review your Plan
                        
                    </ng-template>
                       <!--############## 1stFlights     #################### -->
                           <!--############## 1stFlights     #################### -->
                           <!--############## 1stFlights     #################### -->
                           <!--############## 1stFlights     #################### -->
                           <div class="styled-container">
                            <div class="table-section">
                                <table class="styled-table">
                                    <thead>
                                      <tr><th colspan="2">Total Price Breakup</th></tr>
                                    </thead>
                                    <tbody>
                                      <tr><td>Total Base Price</td><td>INR {{ totalBreakup?.totalBasePrice }}</td></tr>
                                      <tr><td>Tax</td><td>INR {{ totalBreakup?.tax }}</td></tr>
                                      <tr><td>Fee</td><td>INR {{ totalBreakup?.fee }}</td></tr>
                                      <tr><td>GST</td><td>INR {{ totalBreakup?.gst }}</td></tr>
                                      <tr><td>Advance Pricing</td><td>INR {{ advanceTotal }}</td></tr>
                                      <tr class="total-row"><td><strong>Total Price</strong></td><td><strong>INR {{ (totalBreakup?.totalPrice || 0) + (advanceTotal || 0) }}</strong></td></tr>
                                    </tbody>
                                  </table>
                            </div>
                          
                            <div class="table-section">
                              <table class="styled-table">
                                <thead>
                                  <tr>
                                    <th >Travel Category :</th>
                                    <th >{{dataMapping?.insuranceRequest?.geography}}</th>

                                  </tr>
                                </thead>
                                <tbody>
                                  <!-- <tr>
                                    <td>Travel Elite</td>
                                    <td></td>
                                  </tr> -->
                                  <tr>
                                    <th>Plan Type :</th>
                                    <td>{{dataMapping?.insurancePlanSearchResponse?.planType}}</td>
                                  </tr>
                                  <tr>
                                    <th>Pax Type </th>
                                    <th>Premium Amount</th>

                                  </tr>
                                  
                                  <tr *ngFor="let passenger of dataMapping?.insurancePlanSearchResponse?.persons;let i=index">
                                    <td><strong>Person {{i+1}} DOB :</strong> <small>({{passenger?.dobText}})</small></td>

                                    <td>INR {{((passenger?.price || 0) + (this.advancedPricingDataList[i]?.markup || 0))?.toFixed(2)}}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                          
    
                    <mat-divider class="mt-4"></mat-divider>
                    <div class="mt-3">
                      <!-- (click)="onItineraryClick()" -->
                      <button *ngIf="!swingGenerate" mat-raised-button color="accent"  matStepperNext>Continue</button>
                      <button  *ngIf="swingGenerate"  mat-raised-button color="accent" style="margin-right: 2%; width: 100px;"  ><mat-spinner  diameter="30" ></mat-spinner></button>
    
                    </div>
                  </form>
                  
                </mat-step>
                <mat-step [stepControl]="secondFormGroup" >
                  <ng-template matStepLabel >Add traveller details</ng-template>
                  <form [formGroup]="secondFormGroup" class="col-md-12 " >
                    
                    <div >
                      <div class="zoomI">
    
                    <div *ngIf="userType==='EMPLOYEE'" formArrayName="passengerDetails" >
                      <!-- <small class="color-changing-element" *ngIf="!employeeData?.firstName"> Please Update Your Profile Data!</small> -->
    
                      <div *ngFor="let con of passengerDetails.controls; let i=index" [formGroupName]="i" class="row">
                    <mat-label class="bold pt-2 pb-2">Person {{i+1}} <small>({{con?.value?.dob}})</small> </mat-label>
    
                    <mat-form-field *ngIf="privilegesView==='VAMD'" class="col-md-6" appearance="outline" >
              
                      <mat-label>Select Passenger {{i+1}}</mat-label>
                      <mat-chip-grid #chipGrids aria-label="city Selection">
                      </mat-chip-grid>
                      <div class="input-with-icon col-md-12">
                      <input  #travellerInput [formControl]="traveller" 
                        [matChipInputFor]="chipGrids" [matAutocomplete]="autoTo"
                        [matChipInputSeparatorKeyCodes]="separatorKeysCodesTo"
                        (matChipInputTokenEnd)="addTo($event)"
                        />
                        <mat-icon>arrow_drop_down</mat-icon>
                      </div>
        
                      <mat-autocomplete #autoTo="matAutocomplete" (optionSelected)="selectedTo($event)">
                        <mat-option value="" *ngIf="usersList?.length===0">{{'Traveller Not Found'}}</mat-option>
                        <mat-option  *ngFor="let item of filteredTo | async" [value]="item.username"  (click)="onfilterClick(item.username,con)">
                          
                          {{item?.firstName}} {{item?.lastName}}, {{item.username}}
      
                        </mat-option>
                      </mat-autocomplete>
                    </mat-form-field>
                    <mat-label>Traveller name and gender</mat-label>
                    <mat-form-field class="col-md-2" appearance="outline">
                      <mat-label>Title</mat-label>
                      <mat-select matNativeControl name="gender"  formControlName="salutation" >
                        <mat-option [disabled]="!rules.InputPaxInfo" value="MR">Mr</mat-option>
                        <mat-option [disabled]="!rules.InputPaxInfo" value="MRS">Mrs</mat-option>
                        <mat-option [disabled]="!rules.InputPaxInfo" value="MS">Ms</mat-option>
                        <mat-option [disabled]="!rules.InputPaxInfo" value="MSTR">MSTR</mat-option>
                        <mat-option [disabled]="!rules.InputPaxInfo" value="MISS">MISS</mat-option>
  
                        <!-- <mat-option [disabled]="con.value.passengerTitle===passengerDetails.controls[0].value.passengerTitle" value="MR">Male</mat-option>
                        <mat-option [disabled]="con.value.passengerTitle===passengerDetails.controls[0].value.passengerTitle" value="MRS">Female</mat-option>
     -->
                      </mat-select> 
                    </mat-form-field> 
                    <mat-form-field class="col-md-2" appearance="outline">
                      <mat-label>Gender</mat-label>
                      <mat-select matNativeControl name="gender"  formControlName="gender" >
                        <mat-option [disabled]="!rules.InputPaxInfo" value="M">Male</mat-option>
                        <mat-option [disabled]="!rules.InputPaxInfo" value="F">Female</mat-option>
  
                       
                      </mat-select> 
                  </mat-form-field> 
                    <mat-form-field class="col-md-4" appearance="outline">
                      <mat-label>Traveller name</mat-label>
                      <input matInput type="text" name="name" [readonly]="!rules.InputPaxInfo"  formControlName="firstName" >
  
                    </mat-form-field> 
    
                    <mat-form-field class="col-md-4" appearance="outline">
                      <mat-label>Last Name</mat-label>
                      <input matInput type="text" name="lastname" minlength="2" [readonly]="!rules.InputPaxInfo"  formControlName="lastName" >
  
                    </mat-form-field> 
                   
                    <!-- <mat-form-field class="col-md-3 " appearance="outline">
                      <input matInput readonly [matDatepicker]="pickers" formControlName="dob">
                      <mat-label>DOB</mat-label>
                      <mat-hint>MM/DD/YYYY</mat-hint>
                      <mat-datepicker-toggle matIconSuffix [for]="pickers"></mat-datepicker-toggle>
                      <mat-datepicker #pickers></mat-datepicker>
                  </mat-form-field> -->
                   
                    <mat-form-field class="col-md-4" appearance="outline">
                      <mat-label>Email</mat-label>
                      <input matInput type="text" name="email" formControlName="emailId" >
                      <!-- <input  type="hidden" [value]="con.value.username" formControlName="emailId"> -->
      
                    </mat-form-field> 
                    <mat-form-field class="col-md-4" appearance="outline">
                      <mat-label>Mobile Number</mat-label>
                      <input matInput type="text" name="mobile" (keypress)="onlyNumberKey($event)"   formControlName="contactNo">
                    </mat-form-field> 
                    <mat-form-field class=" col-md-4   " appearance="outline">
                      <mat-label>Profile Type	</mat-label>
                      <mat-select name="profile_type"  autocomplete="off" formControlName="profileType">
                        <mat-option value="">--</mat-option>
                <mat-option value="VIP">VIP</mat-option>
                <mat-option value="VVIP">VVIP/CIP</mat-option>
                </mat-select>
                    </mat-form-field>
                    <mat-form-field class="col-md-3 " appearance="outline">
                      <input matInput  formControlName="passportNo">
                      <mat-label> Passport Number	</mat-label>
                  </mat-form-field>
                  <mat-form-field class=" col-md-4   " appearance="outline">
                    <mat-label>Employment Status	</mat-label>
                    <mat-select name="profile_type"  autocomplete="off" formControlName="employmentStatus">
              <mat-option value="Employed">Employed</mat-option>
              <mat-option value="Unemployed">Unemployed</mat-option>
              </mat-select>
                  </mat-form-field>
                  <mat-form-field class=" col-md-4   " appearance="outline">
                    <mat-label> Marital Status	</mat-label>
                    <mat-select name="profile_type"  autocomplete="off" formControlName="maritalStatus">
              <mat-option value="Single">Single</mat-option>
              <mat-option value="Married">Married</mat-option>
              </mat-select>
                  </mat-form-field>
                  <mat-label class="bold pt-2 pb-2"> Nominee {{i+1}} (Should not be Co Traveller) Details.  </mat-label>
                  <mat-form-field class="col-md-4" appearance="outline">
                    <mat-label>Title</mat-label>
                    <mat-select matNativeControl name="gender" formControlName="nomineeSalutation" >
                      <mat-option  value="MR">Mr</mat-option>
                      <mat-option  value="MRS">Mrs</mat-option>
                      <mat-option  value="MS">Ms</mat-option>
                      <mat-option  value="MSTR">MSTR</mat-option>
                          <mat-option value="MISS">MISS</mat-option>
    
                    </mat-select> 
                  </mat-form-field>
                
                  <mat-form-field  class="col-md-4" appearance="outline">
                    <mat-label>Traveller name</mat-label>
                  
                    <input matInput type="text" name="name"  formControlName="nomineeFirstName" >
      
                  </mat-form-field> 
                  <mat-form-field class="col-md-4" appearance="outline">
                    <mat-label>Last Name</mat-label>
                    <input matInput type="text" name="last" minlength="2"formControlName="nomineeLastName" >
      
                  </mat-form-field> 
                  <mat-form-field class="col-md-4" appearance="outline">
                    <mat-label>Relation with Applicant</mat-label>
                    <input matInput type="text" name="last" minlength="2"formControlName="nomineeRelationWithProposer" >
      
                  </mat-form-field> 
                  <mat-form-field class="col-md-4" appearance="outline">
                    <mat-label>Relation with Applicant</mat-label>
                    <mat-select  formControlName="nomineeRelationWithProposer">
                      <mat-option *ngFor="let relation of relations" [value]="relation">
                        {{ relation }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field class="col-md-4" appearance="outline">
                    <mat-label>Date of Birth</mat-label>
                    <input matInput [matDatepicker]="picker" formControlName="nomineeDob"
                           (dateChange)="onDateDobChange($event, i)" />
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                  </mat-form-field>
               
                  <mat-divider class="mt-2 mb-1"></mat-divider>
                </div> </div>
                <div *ngIf="userType==='CORPORATE'||userType==='AGENT'" formArrayName="passengerDetails" >
                 
                  <div class="col-md-5"></div>
                  <div *ngFor="let con of passengerDetails.controls; let i=index" [formGroupName]="i" class="row">
    
                <mat-label class="bold pt-2 pb-2">Person {{i+1}} <small>({{con?.value?.dob}})</small> </mat-label>
                <!-- <mat-form-field class="col-md-5" appearance="outline" *ngIf="!rules.InputPaxInfo"> -->
  
                <mat-form-field *ngIf="userType!='AGENT'" class="col-md-6" appearance="outline" >
              
                  <mat-label>Select Passenger {{i+1}}</mat-label>
                  <mat-chip-grid #chipGrids aria-label="city Selection">
                  </mat-chip-grid>
                  <div class="input-with-icon col-md-12">
                  <input  #travellerInput [formControl]="traveller" 
                    [matChipInputFor]="chipGrids" [matAutocomplete]="autoTo"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodesTo"
                    (matChipInputTokenEnd)="addTo($event)"
                    />
                    <mat-icon>arrow_drop_down</mat-icon>
                  </div>
    
                  <mat-autocomplete #autoTo="matAutocomplete" (optionSelected)="selectedTo($event)">
                    <mat-option value="" *ngIf="usersList?.length===0">{{'Traveller Not Found'}}</mat-option>
                    <mat-option  *ngFor="let item of filteredTo | async" [value]="item.username"  (click)="onfilterClick(item.username,con)">
                      
                      {{item?.firstName}} {{item?.lastName}}, {{item.username}}
  
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
                <mat-label>Traveller name and gender</mat-label>
                <mat-form-field class="col-md-2" appearance="outline">
                  <mat-label>Title</mat-label>
                  <mat-select matNativeControl name="gender" formControlName="salutation" >
                    <mat-option [disabled]="!rules.InputPaxInfo" value="MR">Mr</mat-option>
                    <mat-option [disabled]="!rules.InputPaxInfo" value="MRS">Mrs</mat-option>
                    <mat-option [disabled]="!rules.InputPaxInfo" value="MS">Ms</mat-option>
                    <mat-option [disabled]="!rules.InputPaxInfo" value="MSTR">MSTR</mat-option>
                        <mat-option [disabled]="!rules.InputPaxInfo" value="MISS">MISS</mat-option>
  
                  </mat-select> 
                </mat-form-field>
                <mat-form-field class="col-md-2" appearance="outline">
                  <mat-label>Gender</mat-label>
                  <mat-select matNativeControl name="gender"  formControlName="gender" >
                    <mat-option [disabled]="!rules.InputPaxInfo" value="M">Male</mat-option>
                    <mat-option [disabled]="!rules.InputPaxInfo" value="F">Female</mat-option>
  
                   
                  </mat-select> 
              </mat-form-field> 
                <mat-form-field  class="col-md-4" appearance="outline">
                  <mat-label>Traveller name</mat-label>
                  <!--               <input matInput type="text" name="name" [readonly]="con.value.firstName===passengerDetails.controls[0].value.firstName" formControlName="firstName" >
     -->
                  <input matInput type="text" name="name" [readonly]="!rules.InputPaxInfo" formControlName="firstName" >
    
                </mat-form-field> 
                <mat-form-field class="col-md-4" appearance="outline">
                  <mat-label>Last Name</mat-label>
                  <input matInput type="text" name="last" minlength="2" [readonly]="!rules.InputPaxInfo" formControlName="lastName" >
    
                </mat-form-field> 
                <!-- <mat-form-field class="col-md-3 " appearance="outline">
                  <input matInput readonly [matDatepicker]="pickers" formControlName="dob">
                  <mat-label>DOB</mat-label>
                  <mat-hint>MM/DD/YYYY</mat-hint>
                  <mat-datepicker-toggle matIconSuffix [for]="pickers"></mat-datepicker-toggle>
                  <mat-datepicker #pickers></mat-datepicker>
              </mat-form-field> -->
                
                <mat-form-field class="col-md-4" appearance="outline">
                  <mat-label>Email</mat-label>
                  <input matInput type="text" name="email" formControlName="emailId" >
                  <!-- <input  type="hidden" [value]="con.value.username" formControlName="emailId"> -->
  
                </mat-form-field> 
                <mat-form-field class="col-md-4" appearance="outline">
                  <mat-label>Mobile Number</mat-label>
                  <input matInput type="text" name="mobile" (keypress)="onlyNumberKey($event)"   formControlName="contactNo">
                </mat-form-field> 
                <mat-form-field class=" col-md-4   " appearance="outline">
                  <mat-label>Profile Type	</mat-label>
                  <mat-select name="profile_type"  autocomplete="off" formControlName="profileType">
                    <mat-option value="">--</mat-option>
            <mat-option value="VIP">VIP</mat-option>
            <mat-option value="VVIP">VVIP/CIP</mat-option>
            </mat-select>
                </mat-form-field>
                <mat-form-field class="col-md-4 " appearance="outline">
                  <input matInput  formControlName="passportNo">
                  <mat-label> Passport Number	</mat-label>
              </mat-form-field>
              <mat-form-field class=" col-md-4   " appearance="outline">
                <mat-label>Employment Status	</mat-label>
                <mat-select name="profile_type"  autocomplete="off" formControlName="employmentStatus">
          <mat-option value="Employed">Employed</mat-option>
          <mat-option value="Unemployed">Unemployed</mat-option>
          </mat-select>
              </mat-form-field>
              <mat-form-field class=" col-md-4   " appearance="outline">
                <mat-label> Marital Status	</mat-label>
                <mat-select name="profile_type"  autocomplete="off" formControlName="maritalStatus">
          <mat-option value="Single">Single</mat-option>
          <mat-option value="Married">Married</mat-option>
          </mat-select>
              </mat-form-field>
              <mat-label class="bold pt-2 pb-2"> Nominee {{i+1}} (Should not be Co Traveller) Details.  </mat-label>
              <mat-form-field class="col-md-4" appearance="outline">
                <mat-label>Title</mat-label>
                <mat-select matNativeControl name="gender" formControlName="nomineeSalutation" >
                  <mat-option  value="MR">Mr</mat-option>
                  <mat-option  value="MRS">Mrs</mat-option>
                  <mat-option  value="MS">Ms</mat-option>
                  <mat-option  value="MSTR">MSTR</mat-option>
                      <mat-option value="MISS">MISS</mat-option>

                </mat-select> 
              </mat-form-field>
            
              <mat-form-field  class="col-md-4" appearance="outline">
                <mat-label>Traveller name</mat-label>
              
                <input matInput type="text" name="name"  formControlName="nomineeFirstName" >
  
              </mat-form-field> 
              <mat-form-field class="col-md-4" appearance="outline">
                <mat-label>Last Name</mat-label>
                <input matInput type="text" name="last" minlength="2"formControlName="nomineeLastName" >
  
              </mat-form-field> 
             
              <mat-form-field class="col-md-4" appearance="outline">
                <mat-label>Relation with Applicant</mat-label>
                <mat-select  formControlName="nomineeRelationWithProposer">
                  <mat-option *ngFor="let relation of relations" [value]="relation">
                    {{ relation }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field class="col-md-4" appearance="outline">
                <mat-label>Date of Birth</mat-label>
                <input matInput [matDatepicker]="picker" formControlName="nomineeDob"
                       (dateChange)="onDateDobChange($event, i)" />
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </mat-form-field>
              <span formGroupName="communicationAddress" class="row">

                <mat-form-field class="col-md-4" appearance="outline">
                  <mat-label>Address</mat-label>
                  <input matInput type="text" name="addressLine1"  formControlName="addressLine1">

                </mat-form-field> 
                <mat-form-field class="col-md-4" appearance="outline">
                  <mat-label>State</mat-label>
                  <input matInput type="text"  name="state"  formControlName="state">

                </mat-form-field> 
                <mat-form-field class="col-md-4" appearance="outline">
                  <mat-label>Pincode</mat-label>
                  <input matInput type="text" name="pincode" maxlength="6"  (keypress)="onlyNumberKey($event)" formControlName="pincode">

                </mat-form-field> 
                <mat-form-field class="col-md-4" appearance="outline">
                  <mat-label>City</mat-label>
                  <input matInput type="text" name="cityDistrict"  formControlName="cityDistrict">

                </mat-form-field> 
                <mat-form-field class="col-md-4" appearance="outline">
                  <mat-label>Country</mat-label>
                  <input matInput type="text" name="country"  formControlName="country">

                </mat-form-field> 
              </span>
                <!-- <div formGroupName="userPassportDetails" *ngIf="travelType==='AI'" class="row">
                  <div  class="title" style="text-align: center;">Passport Details</div>
  
                   <mat-form-field  class="col-md-3 " appearance="outline">
                    <mat-label>Issuing Country	</mat-label>
                    <mat-select     formControlName="passportCountry" >
          
                      <mat-option class="mat-primary" *ngFor="let country of staticDataService.countryCache" [value]="country.countryName">{{country.countryName}}</mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-form-field class="col-md-3 " appearance="outline">
                  <input matInput  formControlName="passportNumber">
                  <mat-label>Number	</mat-label>
              </mat-form-field>
                <mat-form-field class="col-md-3 " appearance="outline">
                  <input matInput  [matDatepicker]="PDOB" formControlName="passportDOB" (dateChange)="onDateChange($event, i,'userPassportDetails.passportDOB')">
                  <mat-label>Birth Date	</mat-label>
                  <mat-hint>MM/DD/YYYY</mat-hint>
                  <mat-datepicker-toggle matIconSuffix [for]="PDOB"></mat-datepicker-toggle>
                  <mat-datepicker #PDOB></mat-datepicker>
              </mat-form-field>
              <mat-form-field class="col-md-3 " appearance="outline">
                <input matInput  [matDatepicker]="PDOI" formControlName="passportDOI" (dateChange)="onDateChange($event, i,'userPassportDetails.passportDOI')">
                <mat-label>Issue Date	</mat-label>
                <mat-hint>MM/DD/YYYY</mat-hint>
                <mat-datepicker-toggle matIconSuffix [for]="PDOI"></mat-datepicker-toggle>
                <mat-datepicker #PDOI></mat-datepicker>
            </mat-form-field>
            <mat-form-field class="col-md-3 " appearance="outline">
              <input matInput  [matDatepicker]="PDOE" formControlName="passportDOE" (dateChange)="onDateChange($event, i,'userPassportDetails.passportDOE')">
              <mat-label>Expiry Date</mat-label>
              <mat-hint>MM/DD/YYYY</mat-hint>
              <mat-datepicker-toggle matIconSuffix [for]="PDOE"></mat-datepicker-toggle>
              <mat-datepicker #PDOE></mat-datepicker>
          </mat-form-field>
         
        <mat-form-field class="col-md-3 " appearance="outline">
          <input matInput   formControlName="passportPOI">
          <mat-label>Issuance Place</mat-label>
          
      </mat-form-field>
  
        </div>
        <div formGroupName="userVisaDetails" *ngIf="travelType==='AI'" class="row">
          <div  class="title" style="text-align: center;">VISA Details</div>
  
           <mat-form-field  class="col-md-3 " appearance="outline">
            <input matInput   formControlName="visaNumber">
            <mat-label>Visa Number	</mat-label>
        </mat-form-field>
        <mat-form-field class="col-md-3 " appearance="outline">
          <mat-label>Issuing Country	</mat-label>
          <mat-select     formControlName="issuingCountry" >
          
            <mat-option class="mat-primary" *ngFor="let country of staticDataService.countryCache" [value]="country.countryName">{{country.countryName}}</mat-option>
          </mat-select>
      </mat-form-field>
      <mat-form-field class="col-md-3 " appearance="outline">
        <mat-label>Type of VISA	</mat-label>
        <mat-select     formControlName="type" >
          <mat-option class="mat-primary" value="">--</mat-option>
          <mat-option class="mat-primary" value="B">Business</mat-option>
          <mat-option class="mat-primary" value="T">Tourist</mat-option>
          <mat-option class="mat-primary" value="W">WorkPermit</mat-option>
          <mat-option class="mat-primary" value="G">G4</mat-option>
          <mat-option class="mat-primary" value="S">Student</mat-option>
          <mat-option class="mat-primary" value="D">Dependent</mat-option>
          <mat-option class="mat-primary" value="R">Resident</mat-option>
          <mat-option class="mat-primary" value="M">Migrant</mat-option>
          <mat-option class="mat-primary" value="E">Employee</mat-option>
          <mat-option class="mat-primary" value="H">Hajj</mat-option>
          <mat-option class="mat-primary" value="U">Umrah</mat-option>
          <mat-option class="mat-primary" value="F">FamilyVisa</mat-option>
          </mat-select >
    </mat-form-field>
    <mat-form-field class="col-md-3 " appearance="outline">
      <input matInput  [matDatepicker]="DOI" formControlName="issueDate" (dateChange)="onDateChange($event, i,'userVisaDetails.issueDate')">
      <mat-label>Date of Issue	</mat-label>
      <mat-hint>MM/DD/YYYY</mat-hint>
      <mat-datepicker-toggle matIconSuffix [for]="DOI"></mat-datepicker-toggle>
      <mat-datepicker #DOI></mat-datepicker>
  </mat-form-field>
  <mat-form-field class="col-md-3 " appearance="outline">
    <input matInput  [matDatepicker]="DOE" formControlName="expiryDate" (dateChange)="onDateChange($event, i,'userVisaDetails.expiryDate')">
    <mat-label>Date of Expiry		</mat-label>
    <mat-hint>MM/DD/YYYY</mat-hint>
    <mat-datepicker-toggle matIconSuffix [for]="DOE"></mat-datepicker-toggle>
    <mat-datepicker #DOE></mat-datepicker>
  </mat-form-field>
  <mat-form-field class="col-md-3 " appearance="outline">
  <mat-label>Linked Passport</mat-label>
  <input matInput   formControlName="name">
  
  </mat-form-field>
  </div> -->
              <mat-divider class="mt-2 mb-1"></mat-divider>
            </div> </div>
                 
            
            <div  class="title" style="text-align: center;"> List Of Destination </div>

            <mat-form-field   class="col-md-8" appearance="outline">
              <mat-select  multiple  matNativeControl name="entity"  [(ngModel)]="listOfDestination" [ngModelOptions]="{standalone: true}">
                <mat-option *ngFor="let item of countryList"     [value]="item?.countryName" >{{item?.countryName}}</mat-option>
              </mat-select>
            </mat-form-field> 
            <mat-divider class="mt-2 mb-1"></mat-divider>

          <div *ngIf="userType!='AGENT'" class="title" style="text-align: center;"> Reporting Details</div>
    
          <mat-form-field  *ngIf="userType==='CORPORATE'" class="col-md-8" appearance="outline">
            <mat-label>Billing Entity <span style="color: red;">*</span></mat-label>
            <mat-select-trigger (click)="autoBill.open()">
              <input (input)="autoBill.open()" matInput   placeholder="Search ..." [(ngModel)]="searchQuery" [ngModelOptions]="{standalone: true}" (ngModelChange)="filterEntities()" />
            </mat-select-trigger>
            <mat-select #autoBill="matSelect"  matNativeControl name="entity" required >
              <mat-option *ngFor="let item of filteredEntities"   (click)="addBillingEntity(item)"  [value]="item?.entityName" >{{item?.entityName}} {{item?.entityGST?('('+item?.entityGST+')'):''}}</mat-option>
            </mat-select>
    
            <small *ngIf="!billingDetail" style="color: red;">Please Select Billing Entity! </small>
          </mat-form-field> 
          <mat-form-field  *ngIf="userType==='EMPLOYEE'&&this.DataEntity?.length>1&&!employeeData?.billingEntityuserBookingContext" class="col-md-8" appearance="outline">
            <mat-label>Billing Entity <span style="color: red;">*</span></mat-label>
            <mat-select-trigger (click)="autoBill.open()">
              <input (input)="autoBill.open()" matInput   placeholder="Search ..." [(ngModel)]="searchQuery" [ngModelOptions]="{standalone: true}" (ngModelChange)="filterEntities()" />
            </mat-select-trigger>
            <mat-select #autoBill="matSelect"  matNativeControl name="entity" required >
              <mat-option *ngFor="let item of filteredEntities"   (click)="addBillingEntity(item)"  [value]="item?.entityName" >{{item?.entityName}} {{item?.entityGST?('('+item?.entityGST+')'):''}}</mat-option>
            </mat-select>
    
            <small *ngIf="!billingDetail" style="color: red;">Please Select Billing Entity! </small>
          </mat-form-field> 
    
         
    
          <div class="mt-3 mb-2   col-md-6">
            
          </div>
  <div class="col-md-10" *ngIf="userType!='AGENT'" >
          <div  formArrayName="passengerDetails" >
            <div *ngFor="let con of passengerDetails.controls; let i=index" [formGroupName]="i" class="row">
          <mat-label *ngIf="con.value.lastName" class="bold pt-2 pb-2">Adult {{i+1}} </mat-label>
          <!-- <table class="styled-tables " >
            <thead>
              <tr >
          
              </tr>
            </thead>
            <tbody >
              <tr *ngFor="let tags of con.get('reportingTags').controls; let j = index" [formGroupName]="j">
                <th style="padding: 8px;  text-align: start;" [class]="tags.required==='C'?('form-group required'):''"><label for="" class="">{{tags.displayName}}</label></th>
                <td style="padding: 8px;  text-align: start;" *ngIf="tags.tagValue['show to admin']==='Y'&&!tags.tagFixedValue.includes(':')"><input  type="text" class="form-control"  formControlName="tags.value"></td>
                <td style="padding: 8px;  text-align: start;" *ngIf="tags.tagValue['show to admin']==='Y'&&tags.tagFixedValue.includes(':')"><input  type="text" class="form-control"  [formControlName]="tags.tagFixedValue.split(':')[1]"></td>
  
                </tr>
              </tbody>
              
              </table> -->
              <table *ngIf="con.value.lastName" class="styled-tables "  >
                <tbody formArrayName="reportingTags">
  
                <tr  *ngFor="let tag of getReportingTagsControls(con); let j = index" [formGroupName]="j">
                  <th style="padding: 8px; text-align: start;" [class]="tag.value.required==='C'?('form-group required'):''">
                    <label>{{tag.value.displayName}}</label>
                  </th>
                  <td style="padding: 8px; text-align: start;">
                    <input *ngIf="tag.value['fieldType']==='T'" type="text" class="form-control" formControlName="value" >
                    <!-- <input  type="text" class="form-control" formControlName="value" > -->
                    <mat-select *ngIf="tag.value['fieldType']==='D'" matNativeControl    class="form-control"   formControlName="value">
                      <mat-option class="mat-primary "   *ngFor="let tagValue of tagDropDown(tag.value['checkValue'])" [value]="tagValue">{{tagValue}}</mat-option>
       
                    </mat-select> 
                    <input *ngIf="tag.value['fieldType']==='F'" type="file" class="form-control" (change)="onFileChange($event,j,con)"  formControlName="value" >
  
  
                  </td>
                </tr>
                <tbody >
  
              </table>
              <!-- <table class="styled-tables " >
                <tbody >
  
                <tr  *ngFor="let tag of con.value.reportingTags; let j = index" >
                  <th style="padding: 8px; text-align: start;" [class]="tag.required==='C'?('form-group required'):''">
                    <label>{{tag.displayName}}</label>
                  </th>
                  <td style="padding: 8px; text-align: start;">
                    <input type="text" class="form-control" [(ngModel)]="tag.value" [ngModelOptions]="{standalone: true}">
                  </td>
                </tr>
                </tbody>
              </table> -->
        </div>
        
      </div>
      
      
    
  
  </div>
      
  
          </div>
        </div>
                </form>
                
                <mat-divider class="mt-2 mb-1"></mat-divider>
    
                  <div class="mt-2" (click)="RequiredPopup()">
                    <button mat-raised-button color="accent" matStepperNext (click)="PassengerDetails()" >Continue</button>
                    <!-- <button mat-button (click)="stepper.reset()">Reset</button> -->
                  </div>
                  
                </mat-step>
               
                <mat-step [stepControl]="thirdFormGroup" >
                    <form [formGroup]="thirdFormGroup" class="row">
                      <ng-template matStepLabel>Add contact details</ng-template>
                      
                      <mat-form-field class="col-md-4" appearance="outline">
                        <mat-label>Mobile Number</mat-label>
                        <input matInput type="tel" name="mobile" (keypress)="onlyNumberKey($event)"  formControlName="mobileCtrl">
                        <small *ngIf="thirdFormGroup.controls['mobileCtrl'].dirty && thirdFormGroup.controls['mobileCtrl'].invalid" class="warn">Please enter Mobile Number!</small>
    
                      </mat-form-field> 
                      <mat-form-field class="col-md-4" appearance="outline">
                        <mat-label>Email</mat-label>
                        <input matInput type="email" name="email" formControlName="emailCtrl">
                        <small *ngIf="thirdFormGroup.controls['emailCtrl'].dirty && thirdFormGroup.controls['emailCtrl'].invalid" class="warn">Please enter Email Address!</small>
    
                      </mat-form-field> 
                      <mat-divider class="mt-2"></mat-divider>
                      <mat-form-field class="col-md-4" appearance="outline">
                        <mat-label>Street</mat-label>
                        <input matInput type="text" name="address"  formControlName="address">
                        <small *ngIf="thirdFormGroup.controls['address'].dirty && thirdFormGroup.controls['address'].invalid" class="warn">Please enter Address!</small>
    
                      </mat-form-field> 
                      <mat-form-field class="col-md-4" appearance="outline">
                        <mat-label>State</mat-label>
                        <input matInput type="text"  name="state"  formControlName="state">
                        <small *ngIf="thirdFormGroup.controls['state'].dirty && thirdFormGroup.controls['state'].invalid" class="warn">Please enter State!</small>
    
                      </mat-form-field> 
                      <mat-form-field class="col-md-4" appearance="outline">
                        <mat-label>Pincode</mat-label>
                        <input matInput type="text" name="pincode" maxlength="6"  (keypress)="onlyNumberKey($event)" formControlName="pincode">
                        <small *ngIf="thirdFormGroup.controls['pincode'].dirty && thirdFormGroup.controls['pincode'].invalid" class="warn">Please enter Pincode!</small>
    
                      </mat-form-field> 
                      <mat-form-field class="col-md-4" appearance="outline">
                        <mat-label>City</mat-label>
                        <input matInput type="text" name="city"  formControlName="city">
                        <small *ngIf="thirdFormGroup.controls['city'].dirty && thirdFormGroup.controls['city'].invalid" class="warn">Please enter City!</small>
    
                      </mat-form-field> 
                      <mat-form-field class="col-md-4" appearance="outline">
                        <mat-label>Country</mat-label>
                        <input matInput type="text" name="country"  formControlName="country">
                        <small *ngIf="thirdFormGroup.controls['country'].dirty && thirdFormGroup.controls['country'].invalid" class="warn">Please enter country!</small>
    
                      </mat-form-field> 

                      <mat-divider class="mt-2"></mat-divider>

    
                      <div class="mt-2">
                        <!-- <button mat-raised-button color="accent" matStepperNext>Continue</button> -->
                        <div *ngIf="tripEnable===false" class="mt-2">
                          <button *ngIf="!swingOrderId" mat-raised-button color="accent" (click)=" bookflight()">Continue to payment</button>
                          <button  *ngIf="swingOrderId"  mat-raised-button color="accent" style="margin-right: 2%; width: 100px;"  ><mat-spinner  diameter="30" ></mat-spinner></button>
      
                        </div>
                        <div *ngIf="tripEnable===true" class="mt-2">
                          <button *ngIf="!swingOrderId" mat-raised-button color="accent" (click)=" bookflight()">Continue to payment</button>
                          <button  *ngIf="swingOrderId"  mat-raised-button color="accent" style="margin-right: 2%; width: 100px;"  ><mat-spinner  diameter="30" ></mat-spinner></button>
      
                        </div>
                      </div>
                    </form>
                  </mat-step>
                  <!-- <mat-step [stepControl]="fourthFormGroup" >
                    <form [formGroup]="fourthFormGroup" class="col-md-12 row" >
                      <ng-template matStepLabel >Choose add-ons</ng-template>

                      
                    
                      
    
    
                      <div class="col-md-12 mt-3" style="overflow-y: auto;max-width: 100%;" >
                        
                     
    
    
                </div> 
    
    
    
                 
                    
                      <mat-divider class="mt-2"></mat-divider>
      
                      <div *ngIf="tripEnable===false" class="mt-2">
                        <button *ngIf="!swingOrderId" mat-raised-button color="accent" (click)=" bookflight()">Continue to payment</button>
                        <button  *ngIf="swingOrderId"  mat-raised-button color="accent" style="margin-right: 2%; width: 100px;"  ><mat-spinner  diameter="30" ></mat-spinner></button>
    
                      </div>
                      <div *ngIf="tripEnable===true" class="mt-2">
                        <button *ngIf="!swingOrderId" mat-raised-button color="accent" (click)=" bookflight()">Continue to payment</button>
                        <button  *ngIf="swingOrderId"  mat-raised-button color="accent" style="margin-right: 2%; width: 100px;"  ><mat-spinner  diameter="30" ></mat-spinner></button>
    
                      </div>
                    </form>
                  </mat-step> -->
              </mat-stepper>
            </div>
            <div *ngIf="paymentDetail "  [class]="showSideBar?('col-md-12'):'col-md-9'">
            
              <app-insurance-payment-detail (myOutput)="backClick()"  (hideSideBar)="hideSideBar()"></app-insurance-payment-detail>
    
            </div>
             <!-- <div *ngIf="paymentDetail && showSideBar" class="col-md-12 ">
            
              <app-payment-details (myOutput)="backClick()"  (hideSideBar)="hideSideBar()"></app-payment-details>
    
            </div> -->
            <div  *ngIf="!showSideBar" class="col-md-3" style="background-color: #d2e1f5; border-radius: 4px; content: right; height: 85vh; overflow-y: auto;">
    
    
              <!-- trip-details.component.html -->
    
    <div class="trip-details-container">
    
    
      <div *ngIf="hideAdvancePricing&&loginUserType!='EMPLOYEE'" class="panel mt-3" (click)="togglePanel('advancePrice')">
        <div  class="flex flex-middle flex-between row pt-1 " style="background-color: #1876D1; border-radius: 4px; min-height:30px ;color:white" >
         <div class="col-md-12 input-with-icon" (click)="OnSidebarClick()">
          <span class="fs-5 col-md-6  ">
            <div  class="col-md-12 d-flex justify-content-start bold" style="font-size: 18px;"> 
               Advanced Pricing
            </div>
          </span>
    
          <mat-icon style="font-size: 18px;">open_with</mat-icon>
        </div>
       
        </div> 
      
        <!-- <div *ngIf="expandedPanel === 'advancePrice'" class="panel-content">
        <span  >
          <table  class="styled-tables col-md-12">
            <thead>
              <tr >
                <th style="padding: 8px;  text-align: center;">Base   </th>
                <th style="padding: 8px;  text-align: center;">Tax  </th>
                <th style="padding: 8px;  text-align: center;">Fee  </th>
    
    
    
              </tr>
            </thead>
            <tbody>
              <tr >
               
                <td  style="padding: 8px;">{{''}}</td>
                <td  style="padding: 8px;">{{''}}</td>
                <td  style="padding: 8px;">{{''}}</td>
              
    
              </tr>
              
              
            </tbody>
          </table>
        </span>
    
        </div> -->
      
      </div>
    
    
    
    
    <!--+++++++++++++++++++++++++++++++++++ Price Details ++++++++++++++++++++++++++-->
    <!--+++++++++++++++++++++++++++++++++++ Price Details ++++++++++++++++++++++++++-->
    <!--+++++++++++++++++++++++++++++++++++ Price Details ++++++++++++++++++++++++++-->
    <!--+++++++++++++++++++++++++++++++++++ Price Details ++++++++++++++++++++++++++-->
    <!--+++++++++++++++++++++++++++++++++++ Price Details ++++++++++++++++++++++++++-->
    <!--+++++++++++++++++++++++++++++++++++ Price Details ++++++++++++++++++++++++++-->
    
      <div class="panel mt-1" >
        <div (click)="togglePanel('totalPrice')" class="flex flex-middle flex-between row pt-2 " style="background-color: #1876D1; border-radius: 4px; min-height:50px ;color:white" >
         <div class="col-md-12 input-with-icon">
          <span class="fs-5 col-md-6  ">Total price</span>
          <span  class="col-md-6 spanTotal pb-1 pt-1">INR {{ (totalBreakup?.totalPrice || 0) + (advanceTotal || 0) }}</span>
          
  
          <mat-icon *ngIf="expandedPanel === 'totalPrice'">keyboard_arrow_up</mat-icon>
    
          <mat-icon *ngIf="expandedPanel != 'totalPrice'">keyboard_arrow_down</mat-icon>
        </div>
        </div>    <div *ngIf="expandedPanel === 'totalPrice'" class="panel-content">
          <div class="col-md-12">
            <div class="flexflex-between flex-row"></div>
           
            <!-- <div *ngIf="!orderboolean" class="mt-2 row" style="font-size: 12px; ">
          <span class="col-md-8 pt-1">Base fare ({{travellerDetail?.adult+travellerDetail?.child+travellerDetail?.infantCount}} {{travellerS}})</span>
    
              <span class="col-md-4 pb-1 pt-1">{{fare?.totalPrice||flights?.fare[0]?.baseFare+returnFlights?.fare[0]?.baseFare}} INR</span>
               <mat-divider></mat-divider>
              <span class="col-md-8 pb-1 pt-1">Airline Taxes</span>
              <span class="col-md-4 pb-1 pt-1">{{fare?.totalTax||flights?.fare[0]?.finalTax+returnFlights?.fare[0]?.finalTax}} INR</span>
              <mat-divider></mat-divider>
            
              
              <span class="col-md-8 pb-1 pt-1">Total Price</span>
              <span class="col-md-4 pb-1 pt-1">{{fare?.totalPrice+fare?.totalTax||flights?.fare[0]?.baseFare+flights?.fare[0]?.finalTax+returnFlights?.fare[0]?.baseFare+returnFlights?.fare[0]?.finalTax}} INR</span>
    
    
            </div> -->
            <div class="table-section">
                <table class="styled-table">
                    <!-- <thead>
                      <tr><th colspan="2">Total Price Breakup</th></tr>
                    </thead> -->
                    <tbody>
                      <tr><td>Total Base Price</td><td>INR {{ totalBreakup?.totalBasePrice }}</td></tr>
                      <tr><td>Tax</td><td>INR {{ totalBreakup?.tax }}</td></tr>
                      <tr><td>Fee</td><td>INR {{ totalBreakup?.fee }}</td></tr>
                      <tr><td>GST</td><td>INR {{ totalBreakup?.gst }}</td></tr>
                      <tr><td>Advance Pricing</td><td>INR {{ advanceTotal }}</td></tr>

                      <tr class="total-row"><td><strong>Total Price</strong></td><td><strong>INR {{ (totalBreakup?.totalPrice || 0) + (advanceTotal || 0)}}</strong></td></tr>
                    </tbody>
                  </table>
            </div>
    
          </div>
        </div>
      </div>
    
    <!--+++++++++++++++++++++++++++++++++++ flights Details ++++++++++++++++++++++++++-->
    <!--+++++++++++++++++++++++++++++++++++ flights Details ++++++++++++++++++++++++++-->
    <!--+++++++++++++++++++++++++++++++++++ flights Details ++++++++++++++++++++++++++-->
    <!--+++++++++++++++++++++++++++++++++++ flights Details ++++++++++++++++++++++++++-->
    <!--+++++++++++++++++++++++++++++++++++ flights Details ++++++++++++++++++++++++++-->
    <!--+++++++++++++++++++++++++++++++++++ flights Details ++++++++++++++++++++++++++-->
    
    <!--+++++++++++++++++++++++++++++++++++ flights  ++++++++++++++++++++++++++-->
    <!--+++++++++++++++++++++++++++++++++++ flights  ++++++++++++++++++++++++++-->
    <!--+++++++++++++++++++++++++++++++++++ flights  ++++++++++++++++++++++++++-->
      <div class="panel mt-3" *ngIf="flights" (click)="togglePanel('itinerary')">
        <div class=" flex flex-middle flex-between   row" style="background-color: #1876D1; border-radius: 4px;min-height:50px;color:white"> 
          <div class="col-md-4 "><div class="col-md-12 bold d-flex justify-content-start">{{flights?.flightDetailsList[0]?.fromAirport}}</div><div class="col-md-12 justify-content-start">{{cityFilter(flights?.flightDetailsList[0]?.fromAirport)}}</div></div>
          <div class="col-md-4  d-flex justify-content-center "> <mat-icon class="mt-2">flight_takeoff</mat-icon></div>
    
        <div class="col-md-4   "><div class="col-md-12 bold d-flex justify-content-end">{{flights?.flightDetailsList[flights?.flightDetailsList.length-1]?.toAirport}}</div><div class="col-md-12 d-flex justify-content-end">{{cityFilter(flights?.flightDetailsList[flights?.flightDetailsList.length-1]?.toAirport)}}</div></div>
      </div>
       
    
        <div  class="panel-content">
          <div class="flights " >
    
            <div class="col-md-12 row"> 
              <div class="col-md-4 ">
                <div class="col-md-12 bold d-flex justify-content-start">
                  <img class="carrier-logo"  [src]="flightlogoFilter(flights?.flightDetailsList[0]?.carrierName)"  alt="">
    
                
                </div>
               </div>
        
            <div class="col-md-6 "> <div class="col-md-12 justify-content-start">
              <div class="col-md-12 justify-content-start">{{fligthNameFilter(flights?.flightDetailsList[0]?.carrierName)}}</div>
    
              <div class="col-md-12 flight-number "> {{flights?.flightDetailsList[0]?.carrierName }} - {{ flights?.flightDetailsList[0]?.flightNumber }}</div>
    
            </div>
            
          </div>
          <mat-divider></mat-divider>
          <div class="col-md-12 flights " style="margin-top:0;padding-top: 0;">
            <div class="flight-number bold" style="color: #1876D1;"> Fare Type: </div>
             <div class="flight-number" style="color: #1876D1;">
              <!-- {{flights.fare[0]?.corporateFare?('Corporate'):flights.fare[0].fareType}} -->
              {{flights.fare[0]?.fareTypeDisplay}}
  
            </div>
           </div>
          </div>
         
          </div>
         
    
          
        </div>
      
        <div class="col-md-12 row"> 
          
          <div class="col-md-4 "><div class="col-md-12  d-flex justify-content-start" style="font-size: 10px;">{{dateFormate(flights?.flightDetailsList[0]?.schDepartureTime)}}</div><div class="col-md-12 bold d-flex justify-content-start">{{flights?.flightDetailsList[0]?.fromAirport}}</div><div class="col-md-12 justify-content-start">{{ timeFormate(flights?.flightDetailsList[0]?.schDepartureTime) }}</div><div class="col-md-12  d-flex justify-content-start">{{cityFilter(flights?.flightDetailsList[0]?.fromAirport)}}</div><div class="col-md-12 d-flex justify-content-start">{{flights?.flightDetailsList[0]?.fromTerminal?("Terminal&nbsp;"+flights?.flightDetailsList[0]?.fromTerminal):''}}</div></div>
          <div class="col-md-4  flight-number ">⌚ {{ converter(flights?.travelDuration) }}</div>
    
        <div class="col-md-4   "><div class="col-md-12  d-flex justify-content-end" style="font-size: 10px;">{{dateFormate(flights?.flightDetailsList[flights?.flightDetailsList.length-1]?.schArrivalTime)}}</div><div class="col-md-12 bold d-flex justify-content-end">{{flights?.flightDetailsList[flights?.flightDetailsList.length-1]?.toAirport}}</div><div class="col-md-12 d-flex justify-content-end">{{ timeFormate(flights?.flightDetailsList[flights?.flightDetailsList.length-1]?.schArrivalTime)}}</div><div class="col-md-12  d-flex justify-content-end">{{cityFilter(flights?.flightDetailsList[flights?.flightDetailsList.length-1]?.toAirport)}}</div><div class="col-md-12 d-flex justify-content-end">{{flights?.flightDetailsList[flights?.flightDetailsList.length-1]?.toTerminal?("Terminal&nbsp;"+flights?.flightDetailsList[flights?.flightDetailsList.length-1]?.toTerminal):''}}</div></div>
      </div>
        
      </div>
    <!--+++++++++++++++++++++++++++++++++++ 2flights  ++++++++++++++++++++++++++-->
    <!--+++++++++++++++++++++++++++++++++++ 2flights  ++++++++++++++++++++++++++-->
    <!--+++++++++++++++++++++++++++++++++++ 2flights  ++++++++++++++++++++++++++-->
      <div class="panel mt-3" *ngIf="returnFlights" (click)="togglePanel('itinerary')">
        <div class=" flex flex-middle flex-between   row" style="background-color: #1876D1; border-radius: 4px;min-height:50px;color:white;"> 
          <div class="col-md-4 "><div class="col-md-12 bold d-flex justify-content-start">{{returnFlights?.flightDetailsList[0]?.fromAirport}}</div><div class="col-md-12 justify-content-start">{{cityFilter(returnFlights.flightDetailsList[0]?.fromAirport)}}</div></div>
          <div class="col-md-4  d-flex justify-content-center "> <mat-icon class="mt-2">flight_takeoff</mat-icon></div>
    
        <div class="col-md-4   "><div class="col-md-12 bold d-flex justify-content-end">{{returnFlights?.flightDetailsList[returnFlights?.flightDetailsList.length-1]?.toAirport}}</div><div class="col-md-12 d-flex justify-content-end">{{cityFilter(returnFlights.flightDetailsList[returnFlights.flightDetailsList.length-1]?.toAirport)}}</div></div>
      </div>
       
    
        <div  class="panel-content">
          <div class="flights " >
    
            <div class="col-md-12 row"> 
              <div class="col-md-4 ">
                <div class="col-md-12 bold d-flex justify-content-start">
                  <img class="carrier-logo"  [src]="flightlogoFilter(returnFlights?.flightDetailsList[0]?.carrierName)"  alt="">
    
                </div>
               </div>
        
            <div class="col-md-6 "> <div class="col-md-12 justify-content-start">
              <div class="col-md-12 justify-content-start">{{fligthNameFilter(returnFlights?.flightDetailsList[0]?.carrierName)}}</div>
    
              <div class="col-md-12 flight-number "> {{returnFlights?.flightDetailsList[0]?.carrierName }} - {{ returnFlights?.flightDetailsList[0]?.flightNumber }}</div>
    
            </div></div>
            <mat-divider></mat-divider>
            <div class="col-md-12 flights " style="margin-top:0;padding-top: 0;">
              <div class="flight-number bold" style="color: #1876D1;"> Fare Type: </div>
               <div class="flight-number" style="color: #1876D1;">
                <!-- {{returnFlights.fare[0]?.corporateFare?('Corporate'):returnFlights.fare[0].fareType}} -->
                {{returnFlights.fare[0]?.fareTypeDisplay}}
              </div>
             </div>
          </div>
          
          
            
          </div>
    
          
        </div>
        <div class="col-md-12 row"> 
          <div class="col-md-4 "><div class="col-md-12  d-flex justify-content-start" style="font-size: 10px;">{{dateFormate(returnFlights.flightDetailsList[0]?.schDepartureTime)}}</div><div class="col-md-12 bold d-flex justify-content-start">{{returnFlights.flightDetailsList[0]?.fromAirport}}</div><div class="col-md-12 justify-content-start">{{ timeFormate(returnFlights.flightDetailsList[0]?.schDepartureTime) }}</div><div class="col-md-12  d-flex justify-content-start">{{cityFilter(returnFlights.flightDetailsList[0]?.fromAirport)}}</div><div class="col-md-12 d-flex justify-content-start">{{returnFlights.flightDetailsList[0]?.fromTerminal?("Terminal&nbsp;"+returnFlights.flightDetailsList[0]?.fromTerminal):''}}</div></div>
          <div class="col-md-4   flight-number">⌚ {{ converter(returnFlights?.travelDuration) }}</div>
    
        <div class="col-md-4   "><div class="col-md-12  d-flex justify-content-end" style="font-size: 10px;">{{dateFormate(returnFlights.flightDetailsList[returnFlights.flightDetailsList.length-1]?.schArrivalTime)}}</div><div class="col-md-12 bold d-flex justify-content-end">{{returnFlights.flightDetailsList[returnFlights.flightDetailsList.length-1]?.toAirport}}</div><div class="col-md-12 d-flex justify-content-end">{{ timeFormate(returnFlights.flightDetailsList[returnFlights.flightDetailsList.length-1]?.schArrivalTime)}}</div><div class="col-md-12  d-flex justify-content-end">{{cityFilter(returnFlights.flightDetailsList[returnFlights.flightDetailsList.lenght-1]?.toAirport)}}</div><div class="col-md-12 d-flex justify-content-end">{{returnFlights.flightDetailsList[returnFlights.flightDetailsList.length-1]?.toTerminal?("Terminal&nbsp;"+returnFlights.flightDetailsList[returnFlights.flightDetailsList.length-1]?.toTerminal):''}}</div></div>
      </div>
        
      </div>
    
   <!--+++++++++++++++++++++++++++++++++++ 3flights  ++++++++++++++++++++++++++-->
    <!--+++++++++++++++++++++++++++++++++++ 3flights  ++++++++++++++++++++++++++-->
    <!--+++++++++++++++++++++++++++++++++++ 3flights  ++++++++++++++++++++++++++-->
    <div class="panel mt-3" *ngIf="thirdFlights" (click)="togglePanel('itinerary')">
      <div class=" flex flex-middle flex-between   row" style="background-color: #1876D1; border-radius: 4px;min-height:50px;color:white"> 
        <div class="col-md-4 "><div class="col-md-12 bold d-flex justify-content-start">{{thirdFlights?.flightDetailsList[0]?.fromAirport}}</div><div class="col-md-12 justify-content-start">{{cityFilter(thirdFlights?.flightDetailsList[0]?.fromAirport)}}</div></div>
        <div class="col-md-4  d-flex justify-content-center "> <mat-icon class="mt-2">flight_takeoff</mat-icon></div>
  
      <div class="col-md-4   "><div class="col-md-12 bold d-flex justify-content-end">{{thirdFlights?.flightDetailsList[thirdFlights?.flightDetailsList.length-1]?.toAirport}}</div><div class="col-md-12 d-flex justify-content-end">{{cityFilter(thirdFlights?.flightDetailsList[thirdFlights?.flightDetailsList.length-1]?.toAirport)}}</div></div>
    </div>
     
  
      <div  class="panel-content">
        <div class="flights " >
  
          <div class="col-md-12 row"> 
            <div class="col-md-4 ">
              <div class="col-md-12 bold d-flex justify-content-start">
                <img class="carrier-logo"  [src]="flightlogoFilter(thirdFlights?.flightDetailsList[0]?.carrierName)"  alt="">
  
              
              </div>
             </div>
      
          <div class="col-md-6 "> <div class="col-md-12 justify-content-start">
            <div class="col-md-12 justify-content-start">{{fligthNameFilter(thirdFlights?.flightDetailsList[0]?.carrierName)}}</div>
  
            <div class="col-md-12 flight-number "> {{thirdFlights?.flightDetailsList[0]?.carrierName }} - {{ thirdFlights?.flightDetailsList[0]?.flightNumber }}</div>
  
          </div>
          
        </div>
        <mat-divider></mat-divider>
        <div class="col-md-12 flights " style="margin-top:0;padding-top: 0;">
          <div class="flight-number bold" style="color: #1876D1;"> Fare Type: </div>
           <div class="flight-number" style="color: #1876D1;">
            <!-- {{thirdFlights.fare[0]?.corporateFare?('Corporate'):thirdFlights.fare[0].fareType}} -->
            {{thirdFlights.fare[0]?.fareTypeDisplay}}
  
          </div>
         </div>
        </div>
        
          
        </div>
  
        
      </div>
      <div class="col-md-12 row"> 
        
        <div class="col-md-4 "><div class="col-md-12  d-flex justify-content-start" style="font-size: 10px;">{{dateFormate(thirdFlights?.flightDetailsList[0]?.schDepartureTime)}}</div><div class="col-md-12 bold d-flex justify-content-start">{{thirdFlights?.flightDetailsList[0]?.fromAirport}}</div><div class="col-md-12 justify-content-start">{{ timeFormate(thirdFlights?.flightDetailsList[0]?.schDepartureTime) }}</div><div class="col-md-12  d-flex justify-content-start">{{cityFilter(thirdFlights?.flightDetailsList[0]?.fromAirport)}}</div><div class="col-md-12 d-flex justify-content-start">{{thirdFlights?.flightDetailsList[0]?.fromTerminal?("Terminal&nbsp;"+thirdFlights?.flightDetailsList[0]?.fromTerminal):''}}</div></div>
        <div class="col-md-4  flight-number ">⌚ {{ converter(thirdFlights?.travelDuration) }}</div>
  
      <div class="col-md-4   "><div class="col-md-12  d-flex justify-content-end" style="font-size: 10px;">{{dateFormate(thirdFlights?.flightDetailsList[thirdFlights?.flightDetailsList.length-1]?.schArrivalTime)}}</div><div class="col-md-12 bold d-flex justify-content-end">{{thirdFlights?.flightDetailsList[thirdFlights?.flightDetailsList.length-1]?.toAirport}}</div><div class="col-md-12 d-flex justify-content-end">{{ timeFormate(thirdFlights?.flightDetailsList[thirdFlights?.flightDetailsList.length-1]?.schArrivalTime)}}</div><div class="col-md-12  d-flex justify-content-end">{{cityFilter(thirdFlights?.flightDetailsList[thirdFlights?.flightDetailsList.length-1]?.toAirport)}}</div><div class="col-md-12 d-flex justify-content-end">{{thirdFlights?.flightDetailsList[thirdFlights?.flightDetailsList.length-1]?.toTerminal?("Terminal&nbsp;"+thirdFlights?.flightDetailsList[thirdFlights?.flightDetailsList.length-1]?.toTerminal):''}}</div></div>
    </div>
      
    </div>
  
  <!--+++++++++++++++++++++++++++++++++++ 4flights  ++++++++++++++++++++++++++-->
    <!--+++++++++++++++++++++++++++++++++++ 4flights  ++++++++++++++++++++++++++-->
    <!--+++++++++++++++++++++++++++++++++++ 4flights  ++++++++++++++++++++++++++-->
    <div class="panel mt-3" *ngIf="fourthFlights" (click)="togglePanel('itinerary')">
      <div class=" flex flex-middle flex-between   row" style="background-color: #1876D1; border-radius: 4px;min-height:50px;color:white"> 
        <div class="col-md-4 "><div class="col-md-12 bold d-flex justify-content-start">{{fourthFlights?.flightDetailsList[0]?.fromAirport}}</div><div class="col-md-12 justify-content-start">{{cityFilter(fourthFlights?.flightDetailsList[0]?.fromAirport)}}</div></div>
        <div class="col-md-4  d-flex justify-content-center "> <mat-icon class="mt-2">flight_takeoff</mat-icon></div>
  
      <div class="col-md-4   "><div class="col-md-12 bold d-flex justify-content-end">{{fourthFlights?.flightDetailsList[fourthFlights?.flightDetailsList.length-1]?.toAirport}}</div><div class="col-md-12 d-flex justify-content-end">{{cityFilter(fourthFlights?.flightDetailsList[fourthFlights?.flightDetailsList.length-1]?.toAirport)}}</div></div>
    </div>
     
  
      <div  class="panel-content">
        <div class="flights " >
  
          <div class="col-md-12 row"> 
            <div class="col-md-4 ">
              <div class="col-md-12 bold d-flex justify-content-start">
                <img class="carrier-logo"  [src]="flightlogoFilter(fourthFlights?.flightDetailsList[0]?.carrierName)"  alt="">
  
              
              </div>
             </div>
      
          <div class="col-md-6 "> <div class="col-md-12 justify-content-start">
            <div class="col-md-12 justify-content-start">{{fligthNameFilter(fourthFlights?.flightDetailsList[0]?.carrierName)}}</div>
  
            <div class="col-md-12 flight-number "> {{fourthFlights?.flightDetailsList[0]?.carrierName }} - {{ fourthFlights?.flightDetailsList[0]?.flightNumber }}</div>
  
          </div>
          
        </div>
        <mat-divider></mat-divider>
        <div class="col-md-12 flights " style="margin-top:0;padding-top: 0;">
          <div class="flight-number bold" style="color: #1876D1;"> Fare Type: </div>
           <div class="flight-number" style="color: #1876D1;">
            <!-- {{fourthFlights.fare[0]?.corporateFare?('Corporate'):fourthFlights.fare[0].fareType}} -->
            {{fourthFlights.fare[0]?.fareTypeDisplay}}
          </div>
         </div>
        </div>
        
          
        </div>
  
        
      </div>
      <div class="col-md-12 row"> 
        
        <div class="col-md-4 "><div class="col-md-12  d-flex justify-content-start" style="font-size: 10px;">{{dateFormate(fourthFlights?.flightDetailsList[0]?.schDepartureTime)}}</div><div class="col-md-12 bold d-flex justify-content-start">{{fourthFlights?.flightDetailsList[0]?.fromAirport}}</div><div class="col-md-12 justify-content-start">{{ timeFormate(fourthFlights?.flightDetailsList[0]?.schDepartureTime) }}</div><div class="col-md-12  d-flex justify-content-start">{{cityFilter(fourthFlights?.flightDetailsList[0]?.fromAirport)}}</div><div class="col-md-12 d-flex justify-content-start">{{fourthFlights?.flightDetailsList[0]?.fromTerminal?("Terminal&nbsp;"+fourthFlights?.flightDetailsList[0]?.fromTerminal):''}}</div></div>
        <div class="col-md-4  flight-number ">⌚ {{ converter(fourthFlights?.travelDuration) }}</div>
  
      <div class="col-md-4   "><div class="col-md-12  d-flex justify-content-end" style="font-size: 10px;">{{dateFormate(fourthFlights?.flightDetailsList[fourthFlights?.flightDetailsList.length-1]?.schArrivalTime)}}</div><div class="col-md-12 bold d-flex justify-content-end">{{fourthFlights?.flightDetailsList[fourthFlights?.flightDetailsList.length-1]?.toAirport}}</div><div class="col-md-12 d-flex justify-content-end">{{ timeFormate(fourthFlights?.flightDetailsList[fourthFlights?.flightDetailsList.length-1]?.schArrivalTime)}}</div><div class="col-md-12  d-flex justify-content-end">{{cityFilter(fourthFlights?.flightDetailsList[fourthFlights?.flightDetailsList.length-1]?.toAirport)}}</div><div class="col-md-12 d-flex justify-content-end">{{fourthFlights?.flightDetailsList[fourthFlights?.flightDetailsList.length-1]?.toTerminal?("Terminal&nbsp;"+fourthFlights?.flightDetailsList[fourthFlights?.flightDetailsList.length-1]?.toTerminal):''}}</div></div>
    </div>
      
    </div>
  
  
      
    </div>
    
               
              </div>
            </div>
    
            </div>
          </div>
        </div>
      </div>
           
              
    
      <div class="modal" id="myMod" [style.display]="seatPopup ? 'block' : 'none'" >
        <div class="modal-dialog" >
            <div class="modal-content " >
                <div class="modal-header title">
                  
                  <h4 >Flight Seat Selection</h4>
                  <button  type="button" class="close" data-dismiss="modal" (click)="closePopup()">&times;</button>
    
                  </div>
                  <div class="modal-body"  style="overflow: auto; max-height: 60vh;" >
                    
                    <div class="row col-md-12">
                      <div class="col-md-4 ">
                    <div  class="col-md-12  flightDetails mt-4 " style="overflow-y: auto;height: 60vh; font-size: small; width: 100%;padding: 5px; ">
                      <div style="padding-top: 20px;"></div>
                      <div class="" style="font-size: 16px;text-align: center;font-weight: 700;">{{cityFilter(flightSeatMapping?.fromAirport)+'-'+cityFilter(flightSeatMapping?.toAirport)}}</div>
                      <!-- <mat-paginator  class="col-md-12  mb-1 " style="background-color: transparent;" color="primary"
                      [pageSize]="1"
                      [pageSizeOptions]="[1, 2, 3, 4]"
                      [length]="totalElements"
                      (page)="nextPage($event)"
                      aria-label="Select page"
                      hidePageSize="true">
                      </mat-paginator> -->
    
                      <div class="title" style="font-size: 16px;text-align: center;font-weight: 700;">Passenger</div>
                      <div class="col-md-12 row">
    
                       <div class="col-md-6 row mt-1 mb-1"   *ngFor="let con of flightMealDetails; let i=index" >
                         <div class="col-md-6 pt-1 bold">
                          <!-- con.passengerType==="INF"?("Infant") -->
                          {{con.passengerType==="ADT"?("Adult"):con.passengerType==="CHD"?("Child"):''}}&nbsp;{{i+1}}
                        </div>
                        <div class="col-md-6">
       
                        <li  class="seat" style="width: 30px;height: 25px;" >
                          <input type="checkbox"/>
                         <label *ngIf="flightType==='oneWay'"  style=" background: #bada55; " >{{con.flight.flightDetailsList[flightIndex].seat||'&nbsp;'}}</label>
                         <label *ngIf="flightType==='return'"  style=" background: #bada55; " >{{con.returnFlights.flightDetailsList[flightIndex].seat||'&nbsp;'}}</label>
                         <label *ngIf="flightType==='thirdFlight'"  style=" background: #bada55; " >{{con.thirdFlights.flightDetailsList[flightIndex].seat||'&nbsp;'}}</label>
                         <label *ngIf="flightType==='fourthFlight'"  style=" background: #bada55; " >{{con.fourthFlights.flightDetailsList[flightIndex].seat||'&nbsp;'}}</label>
    
                       </li>
                     </div>
                    </div>
                    <!-- <div class="col-md-6 row mt-1 mb-1"   *ngFor="let con of passengerChild.controls; let i=index" >
                     <div class="col-md-6 pt-1 bold">Child&nbsp;{{i+1}}</div>
                    <div class="col-md-6">
    
                    <li  class="seat" ><input type="checkbox"     />
                     <label  style=" background: #bada55;">&nbsp;</label>
                   </li>
                 </div>
                </div> -->
                <!-- <div class="col-md-6 row mt-1 mb-1"   *ngFor="let con of passengerInfent.controls; let i=index" >
                 <div class="col-md-6 pt-1 bold">Infant&nbsp;{{i+1}}</div>
                <div class="col-md-6">
    
                <li  class="seat" ><input type="checkbox"     />
                 <label  style=" background: #bada55;">&nbsp;</label>
               </li>
             </div>
            </div> -->
           </div>
    
                    <div  class="title" style="font-size: 16px;text-align: center;font-weight: 700;">Legends</div>
    
                      <div class="col-md-12 row mt-1 mb-1" > 
                       <div class="col-md-6 pt-1 bold">Available</div> 
                       <div class="col-md-6">
                       <li  class="seat" style="width: 30px;height: 25px;" ><input type="checkbox"     />
                        <label style=" background: #44a2f7;" >&nbsp;&nbsp;</label>
                      </li>
                    </div>
                   </div>
                   <mat-divider></mat-divider>
    
                      <div class="col-md-12 row mt-1 mb-1">
                        <div class="col-md-6 pt-1 bold">Occupied</div>
                       <div class="col-md-6">
    
                       <li  style="width: 30px;height: 25px;" class="seat" >
                         <input type="checkbox" disabled    />
                        <label  >&nbsp;</label>
                      </li>
                    </div>
                   </div>
                   <mat-divider></mat-divider>
                   <div  class="col-md-12 row mt-1 mb-1">
                     <div class="col-md-6 pt-1 bold">Selected</div>
                    <div class="col-md-6">
    
                    <li  class="seat" style="width: 30px;height: 25px;" ><input type="checkbox"     />
                     <label  style=" background: #bada55;">&nbsp;</label>
                   </li>
                 </div>
                </div>
                <mat-divider></mat-divider>
                <div  class="col-md-12 row mt-1 mb-1">
                  <div class="col-md-6 pt-1 bold">RESTRICTED</div>
                 <div class="col-md-6">
  
                 <li  class="seat" style="width: 30px;height: 25px;" >
                  <input type="checkbox"  disabled   />
                  <label  style=" background: #7d7d7d;">&nbsp;</label>
                </li>
              </div>
             </div>
             <mat-divider></mat-divider>
             <div  class="col-md-12 row mt-1 mb-1">
              <div class="col-md-6 pt-1 bold">CHARGEABLE</div>
             <div class="col-md-6">
  
             <li  class="seat" style="width: 30px;height: 25px;" >
              <input type="checkbox"     />
              <label  style=" background: #d42525;">&nbsp;</label>
            </li>
          </div>
         </div>
         <mat-divider></mat-divider>
    
                       
                       <!-- <div class="col-md-12"><span>Exit Row</span>  </div>
                         <div class="col-md-12" ><span>Paid Offline Seat</span></div> -->
    
                         </div>
                        </div>
    
                     <div *ngIf="seats.length!=0" class="col-md-8" style="overflow-y: auto;height: 60vh; "> 
                      
     <!-- <div class="seat-map " >
     
            <span class="flight">
       <div class="row" *ngFor="let row of rows"  style="padding-left: 100px;" >
         <div class="seat " *ngFor="let seat of seats"  (click)="toggleSeat(row, seat)" [ngClass]="{ 'aisle': isAisle(row, seat) }"  [class.selected]="isSeatSelected(row, seat)">
           <div
             class="seat-item" 
             >
             {{ row }}{{ seat }} 
     
           </div>
           
         </div>
       </div>
     </span>
     </div> -->
     <div  class="plane">
       <div class="cockpit">
         <img src="../../../assets/images/cockpit-top.png" alt="">
         <h3>FRONT</h3>
       </div>
       <div class="exit exit--front fuselage"></div>
       <ol class="cabin fuselage">
         <li *ngFor="let seat of seats" class="row" [class.row--{{row}}]="true">
           <ol class="seats" type="A">
             <li *ngFor="let row of rows" class="seat" [ngbPopover]="popoverContent" container="body"
             triggers="mouseenter:mouseleave" >
               <input  type="checkbox"  [ngClass]="{
                'chargeable': isChargeable(row, seat),
                'restricted': isRestricted(row, seat)
              }" [required]="isrequired(row, seat)" [disabled]="isAisle(row, seat)" id="{{row}}{{seat}}" (click)="toggleSeat(row, seat)"   [class.selected]="isSeatSelected(row, seat)" />
               <label for="{{row}}{{seat}}"  >{{row}}{{seat}}</label>
               <!-- [style]="isRestricted(row, seat)?('background: #7d7d7d;'):isChargeable(row, seat)?('background: #d42525;'):''" -->
               <ng-template #popoverContent class="col-md-12"  >
                <small style="font-size: 10px;">{{popoverSeatPrice(row,seat)}} </small>
                  <!-- and 3405 reviews -->
                
                
                </ng-template>
             </li>
           </ol>
         </li>
       </ol>
      
       <div class="exit exit--back fuselage"></div>
     </div>
     
     </div> 
    </div>
    
    
    
    
        
                </div>
    
                  <div class="modal-footer" >
                    <div class="form-group form-inline ">
                      <label for="userName" class="col-md-5 col-form-label control-label"> </label>
                    </div>   
                      <button type="button" class="btn btn-outline-primary c-width-100px shadow" data-dismiss="modal" (click)="closePopup()">Close</button>
                 
                  </div>
    
                 
    
          </div>
      </div>
    </div>
    <p-sidebar [(visible)]="showSidebar" position="left" styleClass="col-md-8" >
      <ng-template pTemplate="header">
        <strong class="col-md-11 font-semibold text-xl">Advanced Pricing</strong>
          
        <!-- pTemplate="headless" -->
      
    </ng-template>
      
       <table   class="styled-tables col-md-12" >
      <thead>
        <tr >
          <th style="padding: 8px;  text-align: center;">Person </th>
          <th style="padding: 8px;  text-align: center;"> Markup </th>

  
  
        </tr>
      </thead>
      
       
      <tbody   >
        <tr *ngFor="let traveller of advancedPricingDataList;let i=index">
          <td class="value-cell"><strong> {{i+1}}</strong> </td>
          <td class="value-cell">
            <!-- <input (input)="SubmitAdvancePricing($event, i)"  [ngModel]="traveller?.totalMarkup"  type="text" (keypress)="onlyNumberKey($event)"> -->
            <input
            (input)="SubmitAdvancePricing($event, i)"

            [(ngModel)]="traveller.userMarkup"
            name="{{ 'M' + (i + 1) }}"            type="text"
            (keypress)="onlyNumberKey($event)"
          />

          </td>
          </tr>
       
      </tbody>
  
       
  
    
    </table>
    <br>
    <ng-template pTemplate="footer">
      <div class=" d-flex justify-content-end">
    <span class="bold " style="margin-right:10px ;font-size: 23px;">Total Price : {{advanceTotal}} INR </span>
  <button mat-flat-button style="color: white;background-color: #1876D0;" (click)="submit()">Close</button>
    </div>
   </ng-template>
  </p-sidebar>
    
            
              
    
    
        
    